<div class="terms-layout">

  <h1>Terms and Conditions</h1>

  <div class="terms-content">
    <ol>
      <li>'You' means the person who will use Response Master.</li>
      <li>The content and the system that comprise Response Master are the intellectual property of Barbour Logic Ltd.</li>
      <li>
        You will only use Response Master to carry out your work:
        <ul>
          <li>for the organisation you work for; and</li>
          <li>in relation to Penalty Charge Notices issued by the local authority/ies by or for whom a subscription charge for Response Master is being paid to Barbour Logic Ltd.</li>
        </ul>
      </li>
      <li>You may use Response Master to generate letters to send to motorists for the work described in 3. You will not otherwise copy, distribute or transmit Response Master's content.</li>
      <li>You will not modify Response Master.</li>
      <li>You will not reveal how Response Master works to any other person.</li>
      <li>If you do not comply with any of these terms and conditions, you, and the organisation you work for, could face serious legal consequences.</li>
    </ol>
  </div>

</div>
